module.exports = __webpack_public_path__ + "static/media/Electric-Vehicles.41e6f424.svg";